import actions from './actions';

const initState = {
    questionnaires: [],
    questionnaire: {},
    questions: [],
    question: {},
    errors: {},
    karieUsers: [],
    loading: false,
    isSubmittingAssignments: false,
    assignments: [],
    assignErrorMessage: null,
    results: {
        "chartSelectedForQuestions": "line"
    }
};

export default function (state = initState, action) {
    switch (action.type) {
        case actions.FETCH_QUESTIONNAIRES:
            return {
                ...state

            };
        case actions.CREATE_QUESTIONNAIRE:
            return {
                ...state,
                questionnaire: action.questionnaire,
                history: action.history
            };
        case actions.EDIT_QUESTIONNAIRE:
            return {
                ...state,
                questionnaireId: action.questionnaireId,
                questionnaire: action.questionnaire,
                history: action.history
            };
        case actions.DELETE_QUESTIONNAIRE:    
            return {
                ...state,
                questionnaireId: action.questionnaireId
            };
        
        case actions.FRONTEND_VALIDATION:     
            return {
                ...state,
                errors: action.errors
            };
        case actions.CREATE_QUESTIONNAIRE_SUCCESS:
            return {
                ...state,
                questionnaire: action.questionnaire
            };
        case actions.FETCH_QUESTIONNAIRES_SUCCESS:
            return {
                ...state,
                questionnaires: action.questionnaires
            };
        case actions.CREATE_QUESTION:
            return {
                ...state,
                question: action.question,
                questionnaireId: action.questionnaireId,
                history: action.history
            };
        case actions.FETCH_QUESTIONS:
            return {
                ...state,
                questionnaireId: action.questionnaireId
            };
        case actions.FETCH_QUESTIONS_SUCCESS:
            return {
                ...state,
                questions: action.questions
            };
        case actions.FETCH_KARIE_USERS:
            return {
                ...state,
                loading: true,
                questionnaireId: action.questionnaireId,
                assignErrorMessage: null,
            };
        case actions.FETCH_KARIE_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                karieUsers: action.karieUsers,
                assignErrorMessage: null
            };
        case actions.ASSIGN_KARIE_USERS:
            return {
                ...state,
                isSubmittingAssignments: true,
                questionnaireId: action.questionnaireId,
                assignIds: action.assignIds,
                unassignIds: action.unassignIds,
                assignErrorMessage: null,
            };
        case actions.ASSIGN_KARIE_USERS_SUCCESS:
            return {
                ...state,
                isSubmittingAssignments: false,
                assignments: action.assignments,
                karieUsers: action.karieUsers,
                questionnaire: {
                    ...state.questionnaire,
                    assigned: true,
                },
                assignErrorMessage: null,
            };
        case actions.ASSIGN_KARIE_USERS_ERROR:
            return {
                ...state,
                isSubmittingAssignments: false,
                assignErrorMessage: action.message
            };
        case actions.DELETE_QUESTION:    
            return {
                ...state,
                questionnaireId: action.questionnaireId,
                questionId: action.questionId
            };

        default:
            return state;
    }

}
